import * as React from "react";

import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import Offers from "./Offers/container";

import "./style.less";

export type MapProps = RootContainerProps & {};

export interface ActionProps {}

export default (props: ActionProps & MapProps) => (
  <Container className="wsc_content_member_affiliate" {...getContainerProps(props)}>
    <Offers id={props.id} />
  </Container>
);
